import React from "react"
import { VesaRouteType } from "routes"
import Allocation from "pages/production/allocation/Allocation"
import AllocationDetail from "pages/production/allocation/AllocationDetail"
import Palletization from "pages/production/production/Palletization"
import PalletizationDetail from "pages/production/production/PalletizationDetail"
import SalesOrder from "pages/production/salesOrder/SalesOrder"
const PRODUCTION_ROUTES: VesaRouteType[] = [
  {
    icon: "cube",
    title: "Allocation",
    path: "",
    permission: ["ds_view_allocation"],
    element: <Allocation />,
  },

  {
    icon: "cube",
    title: "Allocation Details",
    path: ":id",
    permission: ["ds_view_allocation"],
    element: <AllocationDetail />,
    hide: true,
  },
  {
    icon: "control",
    title: "Sales Order",
    path: "sales-order",
    permission: ["ds_view_sales_order"],
    element: <SalesOrder />,
  },

  {
    icon: "stacked-chart",
    title: "Palletization",
    path: "palletization",
    permission: ["ds_view_palletization"],
    element: <Palletization />,
  },

  {
    icon: "cube",
    title: "Palletization Details",
    path: "palletization/:id",
    permission: ["ds_view_palletization"],
    element: <PalletizationDetail />,
    hide: true,
  },
]

export default PRODUCTION_ROUTES
